import styled from 'styled-components';
import { MetricWidgetBase } from '../../common/mixins';
import breakpoint from 'styled-components-breakpoint';
import BaseTable from 'react-base-table';

export const ViewerWidgetWrapper = styled.div`
  ${MetricWidgetBase};
  height: fit-content;
  padding: 5px 0 !important;

  ${breakpoint('tablet')`
        width: 100%;
    `};

  ${breakpoint('desktop')`
        width: 100%;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const TableWrapper = styled.div`
  min-height: 400px;
  margin: 20px 10px;
  height: 100%;
  position: relative;
`;

export const StyledBaseTable = styled(BaseTable)`
  border: none;
  box-shadow: none;

  .BaseTable__row.selected {
    background-color: #d3e6f9;
  }

  .BaseTable__header,
  .BaseTable__header-row {
    background: transparent;
  }

  .BaseTable__table-main {
    outline: none;
  }

  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 5px 10px;
`;

export const BarIntervalText = styled.div`
  color: #6e6e6e;
  font-size: 0.9em;
  line-height: 2;
  padding: 4px 8px;
  background-color: #f2f2f2;
  border-radius: 6px;
`;

export const IconWrapper = styled.div`
  display: inline-block;
  padding: 0 2px;
`;
